import React from 'react';
import './Blogs.css';

const blogs = [
  {
    title: 'Intro to Unit Testing in .Net',
    image: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/0*VX0b5WHr5Ij2-mFw',
    description: 'An introduction to unit testing in .Net covering best practices and strategies.',
    link: 'https://medium.com/@lankfordr51/intro-to-unit-testing-in-net-f80e093963d2',
  },
  {
    title: 'Beginners Guide to ASP.NET Core MVC',
    image: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*RSi1m_Gvo0VqBY1aAiFv3A.png',
    description: 'A beginners guide to ASP.NET Core MVC covering the basics of the framework and how to get started.',
    link: 'https://medium.com/@lankfordr51/beginners-guide-to-asp-net-core-mvc-96c20087f55c',
  },
  

];

const Blogs = () => (
  <div className="blogs-container">
    <h1 className="blogs-title">My Blogs</h1>
    <div className="blogs-grid">
      {blogs.map((blog, idx) => (
        <div className="blog-card" key={idx}>
          <a href={blog.link} target="_blank" rel="noopener noreferrer">
            <img src={blog.image} alt={blog.title} className="blog-image" />
          
          <div className="blog-desc">
            <h2 className="blog-post-title">{blog.title}</h2>
            <p>{blog.description}</p>
          </div>
          </a>
        </div>
      ))}
    </div>
  </div>
);

export default Blogs; 